export const SOURCE = 'source';
export const OWNER_TEMPLATE = 'owner';
export const USER_TEMPLATE = 'user';
export const CURRENT_TEMPLATE_ID = 'current_id';

